import { MINUTES_PER_DAY } from './timingConstants'

const TIME_PATTERN = /^(\d{1,2}):(\d{1,2})$/

export const parseTimeToMinutes = value => {
  if (typeof value !== 'string') return null

  const match = value.match(TIME_PATTERN)
  if (!match) return null

  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (hours > 23 || minutes > 59) return null

  return hours * 60 + minutes
}

export const getDayOffset = minutes => Math.floor(minutes / MINUTES_PER_DAY)

export const getMinutesInDay = minutes =>
  ((minutes % MINUTES_PER_DAY) + MINUTES_PER_DAY) % MINUTES_PER_DAY

export const formatMinutesAsTime = minutes => {
  const minutesInDay = getMinutesInDay(minutes)
  const hours = Math.floor(minutesInDay / 60)
  const remainingMinutes = minutesInDay % 60

  return `${hours.toString().padStart(2, '0')}:${remainingMinutes.toString().padStart(2, '0')}`
}

export const parsePeriod = period => {
  if (!Array.isArray(period) || period.length !== 2) return null

  const start = parseTimeToMinutes(period[0])
  const end = parseTimeToMinutes(period[1])
  if (start === null || end === null) return null

  return { start, end }
}

export const isZeroPeriod = period => {
  const parsedPeriod = parsePeriod(period)
  return parsedPeriod?.start === 0 && parsedPeriod.end === 0
}
